exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh3.title[data-v-863f5170] {\n  padding: 20px;\n  font-size: 18px;\n  color: #ff5000;\n}\n.col-3[data-v-863f5170] {\n  width: 120px;\n  margin-right: 10px;\n}\n.detail-info[data-v-863f5170] {\n  margin: 0 10px;\n}\n.el-row[data-v-863f5170] {\n  margin-bottom: 10px;\n}\nimg[data-v-863f5170] {\n  max-width: 100px;\n  margin: 0 auto;\n}\n.agreen-info[data-v-863f5170] {\n  margin-top: 20px;\n}\n.agreen-right[data-v-863f5170] {\n  line-height: 40px;\n  text-align: right;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-863f5170","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss","/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/mall/aftersales/detail.vue
// module id = 1634
// module chunks = 0